// WhatsAppToggle.jsx

import React, { useState } from 'react';
import { FaWhatsapp } from 'react-icons/fa';

const whatsappUrl =
  'https://api.whatsapp.com/send/?phone=916399003541&text=Hi%20Arpan%2C%20I%20saw%20your%20portfolio%20and%20want%20to%20discuss%20a%20project%2Fopportunity.&type=phone_number&app_absent=0';

export default function WhatsAppToggle() {
  const [open, setOpen] = useState(false);

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '32px',
        right: '32px',
        zIndex: 1000,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end'
      }}
    >
      {open && (
        <a
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            marginBottom: '12px',
            padding: '14px 22px',
            borderRadius: '32px',
            background: '#25D366',
            color: '#fff',
            fontWeight: 600,
            fontSize: '18px',
            textDecoration: 'none',
            boxShadow: '0 2px 12px rgba(0,0,0,0.18)',
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            transition: 'all 0.2s',
            animation: 'fadeInDown 0.3s'
          }}
        >
          <FaWhatsapp size={24} />
          Chat on WhatsApp
        </a>
      )}

      <button
        onClick={() => setOpen(o => !o)}
        aria-label="Toggle WhatsApp"
        style={{
          width: '58px',
          height: '58px',
          borderRadius: '50%',
          background: '#25D366',
          color: '#fff',
          border: 'none',
          boxShadow: '0 4px 18px rgba(0,0,0,0.16)',
          fontSize: '31px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          transition: 'transform 0.12s',
          outline: 'none'
        }}
      >
        <FaWhatsapp size={32} />
      </button>
      <style>{`
        @keyframes fadeInDown {
          0% { opacity: 0; transform: translateY(18px);}
          100% { opacity: 1; transform: translateY(0);}
        }
        a:hover {
          filter: brightness(0.92);
        }
      `}</style>
    </div>
  );
}
